import Svg, { SvgProps, Path } from 'react-native-svg'

export function PointsOnLoan({ ...props }: SvgProps) {
  return (
    <Svg width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}>
      <Path fill="#00DFC9" d="M4.572 6.649h22.857v6.234H4.572z" />
      <Path
        fill="#223843"
        d="M29.333 8v16c0 .733-.26 1.36-.783 1.883a2.568 2.568 0 0 1-1.883.783H5.333a2.568 2.568 0 0 1-1.883-.783A2.568 2.568 0 0 1 2.667 24V8c0-.734.26-1.361.783-1.884a2.568 2.568 0 0 1 1.883-.783h21.334c.733 0 1.36.261 1.883.783.522.523.783 1.15.783 1.884Zm-24 2.666h21.334V8H5.333v2.666Zm0 5.334v8h21.334v-8H5.333Z"
      />
    </Svg>
  )
}
